export enum FeatureFlags {
  ShowPremium20Web = 'showPremium20Web',
  ShowRedesignedProfileWeb = 'showRedesignedProfileWeb',
}

export const FallbackFeatureFlagValues = {
  [FeatureFlags.ShowPremium20Web]: false,
  [FeatureFlags.ShowRedesignedProfileWeb]: false,
};
